import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import ValueguardLogo from '../assets/images/valueguard-icon-main.webp';
import MapstatLogo from '../assets/images/valueguard-icon-slate-900.webp';
import RegistryLogo from '../assets/images/image-house.webp';
import IndexLogo from '../assets/images/image-priceevolution.webp';
import { DropDown } from '@/components';
import strings from '../language/Swedish';
import { PATH } from '../routes/Paths';

type AppId = 'valuation' | 'mapstat' | 'registry' | 'index';

interface AppEntry {
  id: AppId;
  img: string;
  alt: string;
  text: string;
  path: string;
}

interface Props {
  currentApp: AppId;
}

const AppSwitcher: FC<Props> = ({ currentApp }) => {
  const navigate = useNavigate();

  const apps: AppEntry[] = [
    {
      id: 'valuation',
      img: ValueguardLogo,
      alt: 'Valueguard logo',
      text: strings.sidebar.valueService,
      path: PATH.home,
    },
    {
      id: 'mapstat',
      img: MapstatLogo,
      alt: 'MapStat logo',
      text: strings.sidebar.mapStat,
      path: PATH.mapstat,
    },
    {
      id: 'registry',
      img: RegistryLogo,
      alt: 'Bostadsregistret logo',
      text: strings.sidebar.residentialRegistry,
      path: PATH.residentialRegistry,
    },
    {
      id: 'index',
      img: IndexLogo,
      alt: 'Index logo',
      text: strings.sidebar.indexService,
      path: PATH.indexViewer,
    },
  ];

  const current = apps.find((app) => app.id === currentApp) ?? apps[0];

  const data = {
    trigger: {
      img: current.img,
      alt: current.alt,
      text: current.text,
    },
    items: apps.map(({ id, img, alt, text, path }) => ({
      img,
      alt,
      text,
      handleClick: () => {
        if (id !== currentApp) navigate(path);
      },
    })),
  };

  return <DropDown data={data} imgSize="large" />;
};

export default AppSwitcher;
export type { AppId };
